import React, { FC, HTMLAttributes, PropsWithChildren } from 'react';
import '@/theme/ios-screen.css';

export interface ScreenProps extends HTMLAttributes<HTMLDivElement> {
  /** `narrow` caps the width for forms / reading. */
  width?: 'wide' | 'narrow';
  /** Render as `<main>` (pages outside the app shell, which has its own). */
  asMain?: boolean;
}

/**
 * A bounded, native-feeling screen: exactly the viewport below the top bar
 * (`100dvh - --bh-topbar-h - --kb-inset`), padded for the safe areas. It never
 * scrolls as a page; children split the height with flex (`.bh-screen__fill`
 * for the flexible region).
 */
export const Screen: FC<PropsWithChildren<ScreenProps>> = ({
  width = 'wide',
  asMain = false,
  className,
  children,
  ...rest
}) => {
  const Tag = asMain ? 'main' : 'div';
  return (
    <Tag
      {...rest}
      {...(asMain ? { id: 'main' } : {})}
      className={`bh-screen ${width === 'narrow' ? 'bh-screen--narrow' : ''} ${
        className || ''
      }`}
    >
      {children}
    </Tag>
  );
};
